module.exports = __webpack_public_path__ + "img/Hnk.03e9ccf1.svg";